package ui.app.rss.instance


import androidx.compose.runtime.*
import androidx.compose.ui.text.style.*
import androidx.compose.ui.unit.*
import common.frontend.api.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import tools.*
import ui.widget.*

@Stable
data class AppRssListingInstanceScope(
    val nav: Navigation,
    val vm: AppRssListingInstanceVM,
) {
    companion object {
        @Composable
        fun remember(): AppRssListingInstanceScope {
            val nav = LocalNavigation.current
            val vm = nav.viewModel(AppRssListingInstanceVM::class)

            return remember {
                AppRssListingInstanceScope(
                    nav = nav,
                    vm = vm,
                ).also {
                    vm.init(it)
                }
            }
        }


        val headerSpecs = ListingSpecs.create<Wrapper.Item>(
            ListingSpecs.Item(title = Res.string.layer_bottom_rss_tab_instances_listing__id, width = 50.dp, align = TextAlign.Center) { ListingSpecs.trimmedId(it.data.id) },
            ListingSpecs.Item(title = Res.string.layer_bottom_rss_tab_instances_listing__name, width = 200.dp, lines = 1) { it.data.name },
            ListingSpecs.Item(title = Res.string.layer_bottom_rss_tab_instances_listing__channel, width = 200.dp, lines = 1) { it.data.nameChannel },
            ListingSpecs.Item(title = Res.string.layer_bottom_rss_tab_instances_listing__usage_company, width = 150.dp) { it.data.usageCompany },
            ListingSpecs.Item(title = Res.string.layer_bottom_rss_tab_instances_listing__usage_device, width = 150.dp) { it.data.usageDevice }
        )
    }

    class Wrapper(
        listing: Io.ListingRssInstance
    ) : EFieldList<Io.ListingRssInstance.Item, Wrapper.Item>(
        items = listing.items,
        onBindEntry = { Item(it) }
    ) {
        class Item(
            override val data: Io.ListingRssInstance.Item,
            override val key: String = data.id.toString(),
        ) : Entry<Io.ListingRssInstance.Item>
    }
}
